import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a37c94af7111800146d1687_1782441363952_a3e850b0/nammaprice/src/app/sign-up-login-screen/components/AuthCard.tsx");
